const mapLayoutItem = item => {
  return {
    id: item.i,
    x: item.x,
    y: item.y,
    w: item.w,
    settings: item.settings,
  }
}

export const transformRequestEditOrderTrackingLayout = ({ storeId, layouts }) => {
  return {
    storeId,
    layout: {
      desktop: layouts.desktop.map(mapLayoutItem),
      mobile: layouts.mobile.map(mapLayoutItem),
    },
  }
}
